/*
 * @Author: 赵泽文
 * @Date: 2022-05-10 16:55:45
 * @LastEditors: 彭鑫诚
 * @LastEditTime: 2024-07-18 16:02:29
 * @Description: 退货单数据存储
 */
import type {
  IReturnOrderModel,
  IReturnOrderStore,
} from '@monorepo/types/purchasing/returnOrder/returnOrder.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IReturnOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
  },
  auditNo: '',
  total_money: '0',
  total_use_unit_qty: '0',
};

const returnOrderStore: IReturnOrderModel = {
  namespace: 'returnOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default returnOrderStore;
